import React from 'react';

import { useActor } from '../../components/hooks/useActor';
import { useAnalytics } from './useAnalytics';

export function useIdentifyAnalyticsUser() {
  const analytics = useAnalytics();
  const actor = useActor();

  // Identify user for analytics
  React.useEffect(() => {
    if (!actor.id) {
      return;
    }

    analytics.track('test.pre_identify', {
      uid: actor.id,
      location: 'useIdentifyAnalyticsUser <DashboardWrapper',
    });

    analytics.identify(actor.id, {
      name: actor.fullName,
      email: actor.email,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actor]);
}
